import API_BASE_URL from './apiConfig';
import { getAuthHeaders } from './authApi';

export const listLeads = async (filters = {}, page = 1, limit = 20) => {
  const params = new URLSearchParams({ page, limit });
  if (filters.queryType) params.append('queryType', filters.queryType);
  if (filters.search)    params.append('search',    filters.search);
  if (filters.city)      params.append('city',      filters.city);
  if (filters.state)     params.append('state',     filters.state);
  if (filters.fromDate)  params.append('fromDate',  filters.fromDate);
  if (filters.toDate)    params.append('toDate',    filters.toDate);

  const response = await fetch(`${API_BASE_URL}/im/leads?${params}`, {
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || `HTTP ${response.status}`);
  }
  return response.json();
};

export const getLeadById = async (id) => {
  const response = await fetch(`${API_BASE_URL}/im/leads/${id}`, {
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
  });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.json();
};

export const getSyncLogs = async (limit = 50) => {
  const response = await fetch(`${API_BASE_URL}/im/sync-logs?limit=${limit}`, {
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
  });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.json();
};

export const syncNow = async () => {
  const response = await fetch(`${API_BASE_URL}/im/sync-now`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || `HTTP ${response.status}`);
  }
  return response.json();
};

export const getStatus = async () => {
  const response = await fetch(`${API_BASE_URL}/im/status`, {
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
  });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.json();
};

export const startBackfill = async () => {
  const response = await fetch(`${API_BASE_URL}/im/backfill/start`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || `HTTP ${response.status}`);
  }
  return response.json();
};

export const getBackfillStatus = async () => {
  const response = await fetch(`${API_BASE_URL}/im/backfill/status`, {
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
  });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.json();
};

export const testKey = async () => {
  const response = await fetch(`${API_BASE_URL}/im/test-key`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.message || `HTTP ${response.status}`);
  return data;
};
